module.exports = {
  language: {
    name: '中文'
  },
  user: {
    login: 'OK',
    cancel: 'Cancel',
    loginUsername: 'Please enter your ID first',
    server: 'Select Server',
    activeTitle: 'Activity package',
    activeTiem: 'Event Time',
    name: 'Name',
    level: 'Level',
    claim: 'Claim',
    purchase: 'Purchase',
    rule: 'Rules of Activity',
    imgIdPrompt: "Couldn't find your Player ID",
    promptInfo: 'Please enter a number',
    errorNoInfo: 'No such user in this region',
    receive: 'Receive',
    id: 'Player ID',
    logout: 'Logout',
    title: 'Select Server',
    infoTitle: 'Prompt'
  }
}
